import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-141fcb1e")

_pushScopeId("data-v-141fcb1e")
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-bars menu__icon" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-arrow-left" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.navigation === 'menu')
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "nav__menu",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMenu && _ctx.handleMenu(...args)))
          }, [
            _hoisted_3
          ]))
        : (_ctx.navigation === 'back')
          ? (_openBlock(), _createBlock("div", {
              key: 1,
              class: "nav__back",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
            }, [
              _hoisted_4
            ]))
          : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "body", {}, undefined, true)
  ]))
})